import { Injectable } from '@angular/core';
import { APIService } from '@core/services/api.service';
import { ParkingManagerResponse, ParkingManagerRequest } from '../models/manager-list.model';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable } from 'rxjs';
import { ManagerListReq, ManagerListResponse, ParkingLot } from '../models/parking-manager.model';

@Injectable({
  providedIn: 'root'
})
export class ParkingManagerService {

  constructor(private readonly apiService: APIService) { }

  getManagerListByOwnerId(req: ManagerListReq):Observable<ManagerListResponse> {
    return this.apiService.post<ManagerListResponse>('User/GetManagerListByOwnerId', req)
  }
  getParkingLotByStatesName(stateName: string): Observable<ParkingLot[]> {
    return this.apiService.get<ParkingLot[]>(`Dashboard/GetParkingLotByStatesName?state=${stateName}`);
  }

  createParkingManager(ParkingManagers: ParkingManagerRequest): Observable<ApiResponse<ParkingManagerResponse>> {
    return this.apiService.postWithAllResponse<ParkingManagerResponse>('/User/CreateParkingManager', ParkingManagers);
  }
  getAssignedParkingByManagerId(id: string) {
    return this.apiService.get(`ParkingLot/GetAssignedParkingByManagerId?id=${id}`)
  }
  getParkingManagerDetails(id: string) {
    return this.apiService.get(`User/GetParkingManagerDetails?id=${id}`)
  }
  updateManagerProfile(data: any) {
    return this.apiService.post('User/UpdateManagerProfile', data)
  }
  activateOrDeactivateManagerId(req) {
    return this.apiService.post('User/ActivateOrDeActivateManagerById', req)
  }
}
